// extracted by mini-css-extract-plugin
export default {"xButton":"DebouncingInput_xButton__gKNLi"};